import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ProfileResponse, UpdateProfileInput } from '@teentack/shared';
import { fetchProfile, saveProfile } from '@/lib/api-client';

export const PROFILE_QUERY_KEY = ['profile'] as const;

export function useProfile() {
  return useQuery<ProfileResponse>({
    queryKey: PROFILE_QUERY_KEY,
    queryFn: fetchProfile,
  });
}

/**
 * The PATCH returns the reloaded profile, so the cache is written from the
 * response rather than invalidated — the page never flashes stale values
 * between saving and refetching.
 */
export function useUpdateProfile() {
  const queryClient = useQueryClient();

  return useMutation<ProfileResponse, Error, UpdateProfileInput>({
    mutationFn: saveProfile,
    onSuccess: (result) => {
      queryClient.setQueryData(PROFILE_QUERY_KEY, result);
    },
  });
}
